/**
 * @module-isolated analytics-lab
 * Metas borrador — solo localStorage. No alimenta Resumen ni APIs GAS.
 */
import { useEffect, useState } from 'react';
import { PageHeader, SectionHeader } from '../../../shared/components/index.js';
import LabBanner from '../components/LabBanner.jsx';

const STORAGE_KEY = 'gi-analytics-lab-metas-v1';

const DEFAULT_GOALS = {
  reuniones: '',
  asistenciaPct: '',
  reservas: '',
  cplMeta: '',
  notes: ''
};

function loadGoals() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_GOALS };
    return { ...DEFAULT_GOALS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_GOALS };
  }
}

export default function LabMetasPage() {
  const [goals, setGoals] = useState(DEFAULT_GOALS);
  const [savedAt, setSavedAt] = useState('');
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    setGoals(loadGoals());
  }, []);

  function update(field, value) {
    setGoals((g) => ({ ...g, [field]: value }));
    setDirty(true);
  }

  function save() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(goals));
    const when = new Date().toLocaleString('es-CL');
    setSavedAt(when);
    setDirty(false);
  }

  function clear() {
    localStorage.removeItem(STORAGE_KEY);
    setGoals({ ...DEFAULT_GOALS });
    setSavedAt('');
    setDirty(false);
  }

  return (
    <div className="analytics-module lab-module">
      <LabBanner pageLabel="Metas (borrador)" />
      <PageHeader
        eyebrow="Lab · evaluar UX LeadTrack"
        title="Metas mensuales (borrador)"
        subtitle="Solo en este navegador. No modifica Resumen, Marketing ni ninguna métrica oficial."
      />

      <section className="analytics-section">
        <SectionHeader
          title="Objetivos de equipo"
          note="Estilo LeadTrack (semáforo futuro). Hoy: captura local para evaluar."
        />
        <div className="analytics-panel lab-metas-form">
          <label>
            Reuniones (cantidad / mes)
            <input
              type="number"
              min="0"
              value={goals.reuniones}
              onChange={(e) => update('reuniones', e.target.value)}
              placeholder="ej. 40"
            />
          </label>
          <label>
            Asistencia objetivo (%)
            <input
              type="number"
              min="0"
              max="100"
              value={goals.asistenciaPct}
              onChange={(e) => update('asistenciaPct', e.target.value)}
              placeholder="ej. 70"
            />
          </label>
          <label>
            Reservas (cantidad / mes)
            <input
              type="number"
              min="0"
              value={goals.reservas}
              onChange={(e) => update('reservas', e.target.value)}
              placeholder="ej. 8"
            />
          </label>
          <label>
            CPL Meta techo (CLP)
            <input
              type="number"
              min="0"
              value={goals.cplMeta}
              onChange={(e) => update('cplMeta', e.target.value)}
              placeholder="ej. 25000"
            />
          </label>
          <label className="lab-metas-notes">
            Notas
            <textarea
              rows={3}
              value={goals.notes}
              onChange={(e) => update('notes', e.target.value)}
              placeholder="Contexto del mes, no se publica a nadie más."
            />
          </label>
          <div className="lab-metas-actions">
            <button type="button" className="analytics-btn" onClick={save} disabled={!dirty}>
              Guardar borrador local
            </button>
            <button type="button" className="analytics-btn-ghost" onClick={clear}>
              Borrar borrador
            </button>
            {savedAt ? <span className="lab-muted">Guardado {savedAt}</span> : null}
            {dirty ? <span className="lab-chip is-partial">sin guardar</span> : null}
          </div>
        </div>
      </section>
    </div>
  );
}
